import styled from '@emotion/styled';

export const Main = styled.div`
  width: 100%;
  padding: 40px;
  overflow: auto;
`;